import React from 'react'
import styled from 'styled-components'
import Provider from 'streamr-client-react'
import Hero from './Hero'
import NetworkOverview from './NetworkOverview'
import ConnectToNetwork from './ConnectToNetwork'
import MineDataTokens from './MineDataTokens'
import NetworkUseCases from './NetworkUseCases'
import ExploreNetwork from './ExploreNetwork'
import NetworksCompared from './NetworksCompared'
import Governance from './Governance'
import Tokenomics from './Tokenomics'
import DesignPrinciples from './DesignPrinciples'
import Layout from '~shared/Layout'
import Topic from '~shared/Topic'
import Divider from '~shared/Divider'

const UnstyledLearnNetwork = (props) => (
    <Layout
        {...props}
        nav={(
            <Provider autoConnect autoDisconnect verifySignatures="never">
                <Hero />
            </Provider>
        )}
    >
        <Topic pad head="1rem,2rem,4rem" tail="1rem,2rem,4rem">
            <NetworkOverview />
        </Topic>
        <Topic backgroundColor="#F8F8F8" pad head="6rem,7rem,10.5rem" tail="5rem,7.5rem,19.5rem" color="#0C009A">
            <NetworkUseCases />
        </Topic>
        <Topic head="8rem,2rem,8.375rem" tail="4rem,7.5rem,8.5rem">
            <ExploreNetwork />
        </Topic>
        <Divider />
        <Topic head="3.75rem,5.5rem,4.5rem">
            <ConnectToNetwork />
        </Topic>
        <Topic head="1rem,2rem,4.5rem">
            <MineDataTokens />
        </Topic>
        <Topic head="1rem,2rem,4.5rem">
            <Governance />
        </Topic>
        <Topic head="1rem,2rem,4.5rem" tail="1rem,3.875rem,7.5rem">
            <Tokenomics />
        </Topic>
        <Topic pad head="7.5rem,10.5rem,17.5rem" tail="4.25rem,9.5rem,18.5rem" backgroundColor="#121622" color="#FFFFFF">
            <NetworksCompared />
        </Topic>
        <DesignPrinciples />
    </Layout>
)

const LearnNetwork = styled(UnstyledLearnNetwork)`
    color: #0C009A;
`

export default LearnNetwork
